export type PathsPreset = {
  name: string
  config: {
    count?: number
    segmentsPerPath?: number
    batonLengthRatio?: number
    widthBase?: number
    widthIncrement?: number
    baseOpacity?: number
    opacityIncrement?: number
    colorClass?: string
    speed?: number
    viewW?: number
    viewH?: number
    startX?: number
    startY?: number
    endX?: number
    endY?: number
    curveOffset?: number
    spread?: number
    mirrored?: boolean
    curveSegments?: number
    outflowMargin?: number
  }
}

export const pathPresets: Record<string, PathsPreset> = {
  original: {
    name: 'Original (React-like)',
    config: {
      count: 72,
      segmentsPerPath: 1,
      batonLengthRatio: 0.28,
      widthBase: 0.5,
      widthIncrement: 0.03,
      baseOpacity: 0.08,
      opacityIncrement: 0.02,
      colorClass: 'text-slate-950 dark:text-white',
      speed: 1.2,
      viewW: 696,
      viewH: 316,
      startX: 0,
      startY: 30,
      endX: 696,
      endY: 300,
      curveOffset: 80,
      spread: 6,
      mirrored: true,
      curveSegments: 1,
      outflowMargin: 240,
    },
  },
  aurora: {
    name: 'Aurora',
    config: {
      count: 40,
      segmentsPerPath: 2,
      batonLengthRatio: 0.35,
      widthBase: 0.7,
      widthIncrement: 0.02,
      baseOpacity: 0.1,
      opacityIncrement: 0.008,
      colorClass: 'text-emerald-300/60 dark:text-emerald-200/60',
      speed: 0.8,
      viewW: 696,
      viewH: 316,
      startX: 10,
      startY: 10,
      endX: 686,
      endY: 306,
      curveOffset: 120,
      spread: 10,
      mirrored: true,
      curveSegments: 3,
      outflowMargin: 260,
    },
  },
  waves: {
    name: 'Waves',
    config: {
      count: 28,
      segmentsPerPath: 3,
      batonLengthRatio: 0.22,
      widthBase: 0.6,
      widthIncrement: 0.025,
      baseOpacity: 0.12,
      opacityIncrement: 0.01,
      colorClass: 'text-sky-300/60 dark:text-sky-200/60',
      speed: 1,
      viewW: 696,
      viewH: 316,
      startX: 0,
      startY: 40,
      endX: 696,
      endY: 260,
      curveOffset: 70,
      spread: 8,
      mirrored: false,
      curveSegments: 4,
      outflowMargin: 220,
    },
  },
  circuit: {
    name: 'Circuit',
    config: {
      count: 36,
      segmentsPerPath: 2,
      batonLengthRatio: 0.18,
      widthBase: 0.55,
      widthIncrement: 0.02,
      baseOpacity: 0.14,
      opacityIncrement: 0.008,
      colorClass: 'text-amber-300/50 dark:text-amber-200/50',
      speed: 1.4,
      viewW: 696,
      viewH: 316,
      startX: 10,
      startY: 300,
      endX: 686,
      endY: 16,
      curveOffset: 40,
      spread: 5,
      mirrored: true,
      curveSegments: 2,
      outflowMargin: 200,
    },
  },
  cosmic: {
    name: 'Cosmic',
    config: {
      count: 32,
      segmentsPerPath: 4,
      batonLengthRatio: 0.26,
      widthBase: 0.65,
      widthIncrement: 0.025,
      baseOpacity: 0.1,
      opacityIncrement: 0.012,
      colorClass: 'text-fuchsia-300/60 dark:text-fuchsia-200/60',
      speed: 0.9,
      viewW: 696,
      viewH: 316,
      startX: 0,
      startY: 20,
      endX: 696,
      endY: 296,
      curveOffset: 140,
      spread: 7,
      mirrored: true,
      curveSegments: 3,
      outflowMargin: 240,
    },
  },
}

export type PresetName = keyof typeof pathPresets

